var defaultStyles = {
  "root": "Base-Alert",
  "with_title": "Base-Alert--WithTitle",
  "content": "Base-Alert--Content",
  "title": "Base-Alert--Title",
  "text": "Base-Alert--Text",
  "icon": "Base-Alert--Icon",
  "default": "Base-Alert--Default",
  "success": "Base-Alert--Success",
  "warning": "Base-Alert--Warning",
  "error": "Base-Alert--Error",
  "close": "Base-Alert--Close",
  "action": "Base-Alert--Action"
};

export { defaultStyles as default };
